if (!customElements.get('accordion-grid')) {
  class AccordionGrid extends HTMLElement {
    connectedCallback() {
      this.openFirstItem = this.dataset.openFirstItem === 'true';
      this.cards = Array.from(this.querySelectorAll('[data-accordion-grid-card]'));
      this.openCardEl = null;

      this.handleClick = this.onClick.bind(this);
      this.handleBlockSelect = this.onBlockSelect.bind(this);

      this.addEventListener('click', this.handleClick);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);

      if (this.openFirstItem && this.cards.length > 0) {
        this.openCard(this.cards[0], false);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    onClick(event) {
      const trigger = event.target.closest('[data-accordion-grid-trigger]');

      if (!trigger || !this.contains(trigger)) {
        return;
      }

      const card = trigger.closest('[data-accordion-grid-card]');

      if (!card) {
        return;
      }

      if (card === this.openCardEl) {
        this.closeCard(card);
      } else {
        this.openCard(card, true);
      }
    }

    onBlockSelect(event) {
      if (!this.contains(event.target)) {
        return;
      }

      const card = event.target.closest('[data-accordion-grid-card]');

      if (card) {
        this.openCard(card, true);
      }
    }

    panelForCard(card) {
      const panelId = card
        .querySelector('[data-accordion-grid-trigger]')
        ?.getAttribute('aria-controls');

      if (!panelId) {
        return null;
      }

      return this.querySelector(`#${CSS.escape(panelId)}`);
    }

    openCard(card, closeOthers) {
      if (closeOthers) {
        this.closeAll(card);
      }

      const trigger = card.querySelector('[data-accordion-grid-trigger]');
      const panel = this.panelForCard(card);

      card.classList.add('is-open');
      trigger?.setAttribute('aria-expanded', 'true');

      if (panel) {
        panel.hidden = false;
      }

      this.openCardEl = card;
    }

    closeCard(card) {
      const trigger = card.querySelector('[data-accordion-grid-trigger]');
      const panel = this.panelForCard(card);

      card.classList.remove('is-open');
      trigger?.setAttribute('aria-expanded', 'false');

      if (panel) {
        panel.hidden = true;
      }

      if (this.openCardEl === card) {
        this.openCardEl = null;
      }
    }

    closeAll(exceptCard = null) {
      this.cards.forEach((card) => {
        if (card !== exceptCard && card.classList.contains('is-open')) {
          this.closeCard(card);
        }
      });
    }
  }

  customElements.define('accordion-grid', AccordionGrid);
}
